import React from 'react';

import { useFormContext } from 'react-hook-form';

import {
  ModalInputBox,
  ModalInputGroup,
} from '../../../../../../../shared/components/modals';
import {
  ComboBox,
  OptionWithDescription,
} from '../../../../../../../shared/components/form-components';
import { CompareScanMetricsFormValues } from '../CompareScanMetricsModal.settings';
import { useScanRangeOptions } from '../../../../../../hooks/useScanRangeOptions/useScanRangeOptions';
import { ScanMetadata } from '../../../../../../interfaces/scanMetadata';

type CompareDateFormProps = {
  scansMetadata: ScanMetadata[];
};

const CompareDateForm = ({ scansMetadata }: CompareDateFormProps) => {
  const { control, watch } = useFormContext<CompareScanMetricsFormValues>();
  const { startScanId, endScanId } = watch();

  const { startScanOptions, endScanOptions } = useScanRangeOptions({
    scansMetadata,
    startScanId,
    endScanId,
  });

  const generalInputProps = {
    control,
    variant: 'outlined',
    size: 'small',
  } as const;

  return (
    <ModalInputBox
      title="Select Scans  dates for the period you want to compare"
      showDivider={false}
    >
      <ModalInputGroup>
        <ComboBox
          {...generalInputProps}
          name="startScanId"
          label="Start Scan Date"
          options={startScanOptions}
          renderOptionLabel={(option) => (
            <OptionWithDescription
              label={option.label}
              description={option.description}
            />
          )}
        />
        <ComboBox
          {...generalInputProps}
          name="endScanId"
          label="End Scan Date"
          options={endScanOptions}
          renderOptionLabel={(option) => (
            <OptionWithDescription
              label={option.label}
              description={option.description}
            />
          )}
        />
      </ModalInputGroup>
    </ModalInputBox>
  );
};

export { CompareDateForm };
